/**
 * Bricovibe - Auto-wrap product description into a collapsible
 * équivalent visuel au collapsible_tab du thème Trade.
 */
(function () {
  function wrapDescriptionAsCollapsible() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.bvWrapped === 'true') return;
    if (!desc.textContent || desc.textContent.trim() === '') return;

    var details = document.createElement('details');
    details.className = 'bv-product-desc';
    details.open = false;

    var summary = document.createElement('summary');
    summary.className = 'bv-product-desc__summary';
    summary.innerHTML = '' +
      '<span class="bv-product-desc__left">' +
        '<svg class="bv-product-desc__icon" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M21.3 8.3 8.3 21.3a2.5 2.5 0 0 1-3.5 0L2.7 19.2a2.5 2.5 0 0 1 0-3.5L15.7 2.7a2.5 2.5 0 0 1 3.5 0l2.1 2.1a2.5 2.5 0 0 1 0 3.5z"/>' +
          '<path d="m7.5 10.5 2 2M9.5 8.5l2 2M12 6l2 2M14.5 3.5l2 2M5 13l2 2"/>' +
        '</svg>' +
        '<span class="bv-product-desc__label">Description</span>' +
      '</span>' +
      '<svg class="bv-product-desc__chevron" viewBox="0 0 14 8" width="14" height="8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="1 1 7 7 13 1"/>' +
      '</svg>';

    desc.parentNode.insertBefore(details, desc);
    details.appendChild(summary);
    details.appendChild(desc);
    desc.dataset.bvWrapped = 'true';

    var inner = document.createElement('div');
    inner.className = 'bv-product-desc__inner';
    while (desc.firstChild) inner.appendChild(desc.firstChild);
    desc.appendChild(inner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapDescriptionAsCollapsible);
  } else {
    wrapDescriptionAsCollapsible();
  }

  // Re-run on Shopify section reload (customizer)
  document.addEventListener('shopify:section:load', wrapDescriptionAsCollapsible);
})();
